import { render } from "./DeductionList.vue?vue&type=template&id=0e1880c7&scoped=true&ts=true"
import script from "./DeductionList.vue?vue&type=script&lang=ts"
export * from "./DeductionList.vue?vue&type=script&lang=ts"

import "./DeductionList.vue?vue&type=style&index=0&id=0e1880c7&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1880c7"]])

export default __exports__